import { twMerge } from 'tailwind-merge'
import { useEffect, useState } from 'react'

import { api } from '../services/api.service'

import { style } from '../style'
import { TextAreaField } from './fields'

export default function LostProductForm(props) {
    const [values, setValues] = useState({})
    const [userData, setUserData] = useState(null)

    useEffect(() => {
        api(`${process.env.REACT_APP_API_URL}/app/profile`).then((x) => {
            setUserData(x)
        })
    }, [])

    if (!userData) return <div>Loading...</div>

    return (
        <div>
            <TextAreaField labelClass='text-black' label='Message to finder' value={values.returnInstructions} onChange={(val) => setValues((prev) => ({ ...prev, returnInstructions: val }))}></TextAreaField>

            <br />
            <button
                className={twMerge(style.button.classname, style.button._secondary.classname)}
                onClick={() => {
                    api(`${process.env.REACT_APP_API_URL}/app/mark-as-lost/${props.id}`, values).then((x) => props.submitted())
                }}
                type='button'
            >
                Submit
            </button>
        </div>
    )
}
